
import React from 'react';
import { useUserReport } from '@/hooks/useUserReport';

const HeaderSection = () => {
  const { data: report } = useUserReport();

  const formatFloorSize = (size: number | undefined) => {
    if (!size) return 'N/A';
    return `${size.toLocaleString('en-GB')} sq ft`;
  };

  const getEpcColor = (rating: string | undefined | null) => {
    switch (rating) {
      case 'A':
        return '#F2FCE2'; // Soft Green
      case 'B':
        return '#D3E4FD'; // Soft Blue
      case 'C':
        return '#FEF7CD'; // Soft Yellow
      case 'D':
        return '#FEC6A1'; // Soft Orange
      case 'E':
        return '#FFDEE2'; // Soft Pink
      case 'F':
        return '#FDE1D3'; // Soft Peach
      case 'G':
        return '#ea384c'; // Red
      default:
        return '#F59E0B'; // Default Orange
    }
  };

  const getEpcTextColor = (rating: string | undefined | null) => {
    // Use white text for rating G (dark background), black for others (light background)
    return rating === 'G' ? 'text-white' : 'text-black';
  };

  return (
    <section className="w-full bg-gradient-to-r from-[#ECFDF5] to-white py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#111827] mb-8">
          Insights
        </h1>
        
        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="grid grid-cols-5 gap-4 min-w-0">
            <div className="flex flex-col gap-2 min-w-0">
              <h3 className="font-bold text-base text-black truncate">{report?.area || 'N/A'}</h3>
              <span className="text-sm font-semibold text-[#4B5563]">Area</span>
            </div>
            
            <div className="flex flex-col gap-2 min-w-0">
              <h3 className="font-bold text-base text-black truncate">{report?.building_type || 'N/A'}</h3>
              <span className="text-sm font-semibold text-[#4B5563]">Building Type</span>
            </div>
            
            <div className="flex flex-col gap-2 min-w-0">
              <h3 className="font-bold text-base text-black truncate">{formatFloorSize(report?.floor_size)}</h3>
              <span className="text-sm font-semibold text-[#4B5563]">Floor Size</span>
            </div>
            
            <div className="flex flex-col gap-2 min-w-0">
              <h3 className="font-bold text-base text-black truncate">{report?.occupants || 'N/A'}</h3>
              <span className="text-sm font-semibold text-[#4B5563]">Occupants</span>
            </div>
            
            <div className="flex flex-col gap-2 min-w-0">
              <div 
                className={`w-[80px] h-[40px] rounded-full flex items-center justify-center`}
                style={{ backgroundColor: getEpcColor(report?.energy_rating) }}
              >
                <span className={`font-bold text-base ${getEpcTextColor(report?.energy_rating)}`}>
                  EPC {report?.energy_rating || 'N/A'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeaderSection;
